import React from 'react';

type SvgnotificationsProps = React.SVGProps<SVGSVGElement>;

const Svgnotifications: React.FC<SvgnotificationsProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_969_14346)">
      <path
        d="M10.3092 4.51127C10.3092 3.32173 11.2735 2.35742 12.463 2.35742C13.6526 2.35742 14.6169 3.32173 14.6169 4.51127C17.1371 5.70294 18.7939 8.18815 18.9246 10.9728V14.2036C19.0889 15.5614 19.8883 16.7604 21.0784 17.4343H3.84766C5.03778 16.7604 5.83715 15.5614 6.0015 14.2036V10.9728C6.13221 8.18815 7.78901 5.70294 10.3092 4.51127Z"
        fillRule="evenodd"
        stroke="#5F6D7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.91"
      />
      <path
        d="M9.22656 17.4355V18.5125C9.22656 20.2968 10.673 21.7432 12.4573 21.7432C14.2416 21.7432 15.6881 20.2968 15.6881 18.5125V17.4355"
        stroke="#5F6D7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.91"
      />
    </g>
    <defs>
      <clipPath id="clip0_969_14346">
        <rect height="24" width="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Svgnotifications;
